import { useToastStore } from '../stores/toastStore'

// Multer + the server's errorHandler put the human-readable reason in
// `response.data.error` (e.g. "File too large", "This file type is
// blocked for security"). Network failures don't have a response at
// all. Map both to a toast so an upload failure never silently dies in
// the console.
export function showUploadError(err: any, fallbackTitle = 'Upload failed') {
  const serverMsg: string | undefined = err?.response?.data?.error
  const status: number | undefined = err?.response?.status
  let body = serverMsg
  if (!body) {
    if (status === 413) body = 'File is too large'
    else if (err?.code === 'ERR_NETWORK' || err?.message?.includes('Network')) body = 'Network error — check your connection'
    else body = err?.message || 'Something went wrong'
  }
  useToastStore.getState().showToast({
    id: `upload-error-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    type: 'error',
    title: fallbackTitle,
    body,
  })
}
